import * as Sentry from "@sentry/nextjs";

Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

    // Sample rate for performance monitoring
    // 1.0 = 100% of transactions, 0.1 = 10% (recommended for production)
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,

    // Only enable debug mode in development
    debug: process.env.NODE_ENV === 'development',
});
